import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "range-variant" }
const _hoisted_2 = { class: "range-variant__values" }
const _hoisted_3 = { class: "range-variant__container" }
const _hoisted_4 = ["value", "onInput", "disabled"]

import { ref, watch, onMounted, PropType } from "vue";
import { debounce } from "lodash";

// Определите типы для ваших входных данных
interface Variant {
  count: number;
  percentage: number;
}

// Определите props с использованием синтаксиса defineProps
const minGap = 0;


export default /*@__PURE__*/_defineComponent({
  __name: 'RangeVariant',
  props: {
  variants: {
    type: Array as PropType<Variant[]>,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["change-variants"],
  setup(__props, { emit: __emit }) {

const props = __props;

// Data и Reactivity
const items = ref<Variant[]>(props.variants); // используйте ref для реактивных данных
const emit = __emit;

// Следите за изменениями в props.variants
watch(
  () => props.variants,
  (newValue) => {
    items.value = newValue;
  },
  { immediate: true }
);

// Методы
const slide = (e: Event, index: number) => {
  const target = e.target as HTMLInputElement;
  const previousValue = target.previousSibling as HTMLInputElement;
  const nextValue = target.nextSibling as HTMLInputElement;

  if (
    previousValue &&
    parseInt(target.value) - parseInt(previousValue.value) <= minGap
  ) {
    target.value = (parseInt(previousValue.value) + minGap).toString();
  } else if (
    nextValue &&
    parseInt(nextValue.value) - parseInt(target.value) <= minGap
  ) {
    target.value = (parseInt(nextValue.value) - minGap).toString();
  }

  if (items.value[index]) {
    items.value[index].count = parseInt(target.value);
    if (items.value[index + 1]) {
      items.value[index + 1].percentage =
        items.value[index + 1].count - items.value[index].count;
    }
    if (index > 0) {
      items.value[index].percentage =
        items.value[index].count - items.value[index - 1].count;
    } else if (items.value.length > 1) {
      items.value[index].percentage = items.value[index].count;
    }
  }

  onChangeDebounced();
};

// Debounced onChange - используйте onMounted для инициализации
let onChangeDebounced = () => {
  emit("change-variants", items.value);
};
onMounted(() => {
  onChangeDebounced = debounce(onChangeDebounced, 400);
});

const getColor = (index: number): string => {
  const colors = ["green", "yellow", "red", "blue", "violet", "gray"];
  return colors[index % colors.length] ?? colors[0];
};

const getZindex = (index: number) => {
  const itemsCount = items.value.length;
  if (
    itemsCount > 2 &&
    index === itemsCount - 3 &&
    items.value[itemsCount - 1].percentage === 0
  ) {
    return 2;
  }
  return 1;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["range-variant__value", getColor(index)])
        }, _toDisplayString(item.percentage), 3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "range-variant__slider-track" }, null, -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
        return (_openBlock(), _createElementBlock("input", {
          key: index,
          type: "range",
          min: "0",
          max: "100",
          value: item.count,
          style: _normalizeStyle({
          display:
            items.value.length > 1 && index === items.value.length - 1 ? 'none' : 'block',
          zIndex: getZindex(index),
        }),
          onInput: ($event: any) => (slide($event, index)),
          disabled: __props.disabled
        }, null, 44, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})